import { Box, HStack, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { colors } from "../../styles";
import { formatPrice } from "../../utils";

interface IHMedicineListItemProps {
    index: number;
    id: string;
    medicineImage: string;
    seller: string;
    nameKor: string;
    packageUnit: string;
    basePrice: string;
    unitPrice: string;

    onOpen?: () => void;
}

function HMedicineListItem({ index, id, medicineImage, seller, nameKor, packageUnit, basePrice, unitPrice, onOpen }:IHMedicineListItemProps) {

    /* packImage 배열 */

    const [packImage, setPackImage] = useState<string[]>([]);

    /* unitPrice 배열 */

    const [unitPriceArray, setUnitPriceArray] = useState<any[]>([]);

    /* unitPrice 처리 */

    useEffect(() => {

        ////////////////////////////////////////////////////////////////////// packImage 처리

        const urlString = medicineImage;
        
        if(urlString) {
            const urlArray = urlString.split(';');
            setPackImage(urlArray);
        }

        ////////////////////////////////////////////////////////////////////// unitPrice 처리

        if(unitPrice) {

            const result = unitPrice.split(";").map((item, index, array) => {
                const [count, price] = item.split("|").map(Number);
                    // 첫 번째 요소의 가격을 기준으로 할인율 계산
                const basePriceNumber = Number(basePrice);
                const discount = Math.round(((basePriceNumber - price) / basePriceNumber) * 1000) / 10;

                return { count, price, discount };
            })

            if(result) {
                setUnitPriceArray(result);
            }

        }
    }, [medicineImage, unitPrice, basePrice]);

    /* miniMedicineName */

    const miniMedicineName = useMemo(() => {
        return nameKor ? nameKor.split('(')[0].trim() : "-";
    }, [nameKor]);

    /* render */

    return (
        <Stack
            onClick={() => {
                onOpen?.();
                window.open(`/medicine/${id}`, '_blank', 'noopener,noreferrer');
            }}

            minWidth={"220px"}

            // Fade and slight slide animation for each box
            animation="fadeBox 0.6s"
            sx={{
                animationDelay: `${index * 0.08 + 0.22}s`,
                animationFillMode: "backwards",
                '@keyframes fadeBox': {
                    from: {
                        opacity: 0,
                        transform: 'translateY(18px) scale(0.97)'
                    },
                    to: {
                        opacity: 1,
                        transform: 'none'
                    }
                }
            }}
        >
            <Box position={"relative"}>
                <Image
                    src={packImage[0] ?? "/png/nutrients.png"} 
                    width={{
                        base: 140,
                        sm: 160,
                        md: 180,
                        lg: 180,
                        xl: 220
                    }} 
                    minWidth={{
                        base: 140,
                        sm: 160,
                        md: 180,
                        lg: 180,
                        xl: 220
                    }}
                    maxWidth={{
                        base: 140,
                        sm: 160,
                        md: 180,
                        lg: 180,
                        xl: 220
                    }}
                    minHeight={{
                        base: 140,
                        sm: 160,
                        md: 180,
                        lg: 180,
                        xl: 220
                    }}
                    height={{
                        base: 140,
                        sm: 160,
                        md: 180,
                        lg: 180,
                        xl: 220
                    }} 
                    maxHeight={{
                        base: 140,
                        sm: 160,
                        md: 180,
                        lg: 180,
                        xl: 220
                    }}

                    border={`1px solid ${colors.g5}`}
                    borderRadius={"8px"} 
                    objectFit={"contain"}
                />
            </Box>

            {/* 약품 정보 */}

            <VStack 
                width={"100%"}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                marginTop={2}
                spacing={1}
            >
                <Text fontSize={14} fontWeight={700} color={colors.g3}>{seller ?? "-"}</Text>
                <HStack>
                    <Text fontSize={14} fontWeight={700} color={colors.g1}>{miniMedicineName}</Text>
                </HStack>
                <Text fontSize={14} fontWeight={400} color={colors.g3}>{(!packageUnit || packageUnit === "NULL") ? "-" : packageUnit}</Text>
            </VStack>
        </Stack>
    )
}

export default React.memo(HMedicineListItem);